<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';
  import { APP_CONSTANTS } from '../../../common/config/app-constants';
  import { globalCurrencyTag } from '../../../common/util';
  import Text from '../../common/components/Text.svelte';
  import { addHomeMaintenanceToCart } from '../service/home-maintenance-data-services';

  const { themeResourcePath } = getAppConfig();

  export let backgroundImage = `${APP_CONSTANTS.AMPLIENCE_IMAGE_BASE_URL}promote-vip-bg`;

  export let starIcon = `${themeResourcePath}/images/homeservices/vipstar.svg`;

  export let service;

  export let isVipMember = false;

  export let vipTextBg = `${themeResourcePath}/images/homeservices/vip-off-bg.png`;

  export let source = window.ACC.constants.PAGESOURCE.HOMESERVICEPOPUP;
</script>

{#if service?.product?.homeMaintenanceVipData}
  {#if isVipMember}
    <div class="old-price">
      <span class="old-amount">{service?.price}</span>
      <span class="saved-amount">
        <Text
          key="extra.cart.saved.amt"
          args={[globalCurrencyTag, `${service?.product?.homeMaintenanceVipData?.vipDiscount?.formattedValue}`]}
        />
      </span>
    </div>
  {:else}
    <div
      class="vip-container d-flex align-items-center justify-content-between"
      style="background-image: url('{backgroundImage}')"
    >
      <!-- LEFT -->
      <div class="vip-offer-details d-flex flex-column">
        <div class="vip-offer-title d-flex align-items-center gap-1">
          <img src={starIcon} alt="star" />

          <span class="vip-text" style="background-image: url('{vipTextBg}')">
            <Text key="extra.home.service.vip.price.text" />
          </span>

          <img src={starIcon} alt="star" />
        </div>

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="vip-link" on:click={() => addHomeMaintenanceToCart({ vipAddToCart: true, source: source })}>
          <Text key="extra.home.service.become.vip" />
        </div>
      </div>

      <!-- RIGHT -->
      <div class="vip-price-details d-flex flex-column">
        <div class="vip-price">
          <Text
            key="jood.price.with.currency"
            args={[globalCurrencyTag, `${service?.product?.homeMaintenanceVipData?.vipPrice?.formattedValue}`]}
          />
        </div>

        <div class="vip-off" style="background-image: url('{vipTextBg}')">
          <Text
            key="extra.home.service.vip.price.off"
            args={[service?.product?.homeMaintenanceVipData?.vipPercentageDiscount?.formattedValue]}
          />
        </div>
      </div>
    </div>
  {/if}
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .vip-container {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: $primary-white;
    padding: 8px;
    border-radius: 8px;
    gap: 16px;
  }

  /* LEFT */
  .vip-offer-details {
    gap: 10px;
  }

  .vip-offer-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 700;
    font-size: 18px;
    img {
      height: 6px;
    }
  }

  .vip-text {
    background-size: cover;
    background-position: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-weight: 700;
    font-size: 15px;
    line-height: 16px;
    white-space: nowrap;
  }

  .vip-link {
    color: $primary-white !important;
    text-decoration: underline;
    font-weight: 700;
    font-size: 11px;
    line-height: 11px;
    text-indent: 10px;
    cursor: pointer;
    @include desktop-max-width {
      font-size: 10px;
    }
  }

  .vip-price-details {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
  }

  .vip-price {
    font-size: 16px;
    color: $primary-white;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 2px;
  }

  .vip-off {
    color: $black;
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: 700;
    font-size: 9px;
    line-height: 10px;
  }
</style>
